<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">TBA Content Listing</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard"> Dashboard </router-link>
      /

      <b>TBA</b> / <b>Content Listing</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- New -->
        <div></div>
        <div class="card text-left">
          <div class="card-body">
            <p>The table below shows the submitted content listing for CHP.</p>
            <div class="table-responsive">
              <table
                id="content_table"
                class="display table table-striped table-bordered"
                style="width: 100%; text-align: center"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Name</th>
                    <th>IC No</th>
                    <th>Mobile No.</th>
                    <th>Order ID</th>
                    <th>Certificate</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Updated on</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(content, index) in contents" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ content.name }}</td>
                    <td>{{ content.ic_number }}</td>
                    <td>{{ content.mobile_no }}</td>
                    <td>{{ content.bpgs_id }}</td>
                    <td>{{ content.certificate_no }}</td>
                    <td>{{ content.start_date }}</td>
                    <td>{{ content.expiry_date }}</td>
                    <td>{{ content.updated_at }}</td>
                    <td>
                      <router-link
                        :to="contentDetail(content.id)"
                        type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78be20; border-color: #78be20"
                        >View</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { getContentCoverages } from "../../../services/ContentCoverageService";
import moment from "moment";
export default {
  name: "content-listings",
  components: {},
  data() {
    return {
      contents: [],
      datatable: null,
    };
  },

  methods: {
    async loadContentCoverages() {
      try {
        const response = await getContentCoverages();
        if (response.data.success) {
          this.contents = response.data.data;

          this.initializeDatatable();
        }
      } catch (error) {
        console.error(error);
      }
    },

    initializeDatatable() {
      if (this.datatable) {
        this.datatable.destroy();
      }

      // Initialize new datatable
      this.$nextTick(() => {
        this.datatable = $("#content_table").DataTable({
          pageLength: 10,
          lengthMenu: [10, 25, 50, 100],
          dom: "Bfrtip",
          buttons: ["excel", "pdf"],
        });
      });
    },

    destroyDatatable() {
      const tables = ["#content_table"];
      tables.forEach((table) => {
        if ($.fn.DataTable.isDataTable(table)) {
          $(table).DataTable().destroy();
        }
      });
    },

    contentDetail(id) {
      return "/tba/content/" + id + "/details";
    },
  },

  mounted() {
    this.loadContentCoverages();
  },

  beforeDestroy() {
    // Clean up datatable
    if (this.datatable) {
      this.datatable.destroy();
    }
  },
};
</script>
